import emp_icon_ijp from "../../images/emp-dashboard/dash-1.jpg";
import emp_icon_policy from "../../images/emp-dashboard/dash-2.jpg";
import emp_icon_holiday from "../../images/emp-dashboard/dash-3.jpg";
import emp_icon_permission from "../../images/emp-dashboard/dash-4.jpg";
import emp_icon_leave from "../../images/emp-dashboard/dash-5.jpg";
import emp_icon_project from "../../images/emp-dashboard/dash-6.jpg";
import emp_icon_opinion from "../../images/emp-dashboard/dash-7.jpg";
import emp_icon_lop from "../../images/emp-dashboard/dash-9.jpg";
import emp_payroll_generate from "../../images/emp-dashboard/dash-10.jpg";
import emp_leave_balance_update from "../../images/emp-dashboard/dash-11.jpg";
import emp_loan_details from "../../images/emp-dashboard/dash-14.jpg";

export const dashboardOptions = [
  {
    id: 2,
    label: "Loss of Pay List",
    link: "/app/employee/lop-details",
    color: "#C5D3E8",
    // color:"#A6AEBF",
    image: emp_icon_lop,
  },
  // {
  //   id: 212390,
  //   label: "Generate Payslip",
  //   link: "/app/employee/generate-payslip",
  //   icon: (
  //     <IconButton>
  //       <ArrowLeftIcon />
  //     </IconButton>
  //   ),
  // },
  {
    id: 3,
    label: "Projects",
    link: "/app/employee/projects",
    color: "#D0E8C5",
    image: emp_icon_project,
  },
  {
    id: 4,
    label: "Employee Opinions",
    link: "/app/employee/opinions/yet-to-reply",
    color: "#FFE2E2",
    image: emp_icon_opinion,
  },
  {
    id: 5,
    label: "Leave Management",
    link: "/app/employee/leave/yet-to-approve",
    color: "#C4E1F6",
    image: emp_icon_leave,
  },
  {
    id: 7,
    label: "Permissions Management",
    link: "/app/employee/permission/yet-to-approve",
    color: "#FEEE91",
    image: emp_icon_permission,
  },
  {
    id: 2190,
    label: "Internal Job Posting",
    link: "/app/employee/internal-jobpostings",
    color: "#CDC1FF",
    image: emp_icon_ijp,
  },
  {
    id: 77,
    label: "List of Holidays",
    link: "/app/employee/leave-calendar",
    color: "#B3C8CF",
    image: emp_icon_holiday,
  },
  {
    id: 92183,
    label: "Policy Handbook",
    link: "/app/employee/policy-handbook",
    color: "#E5E1DA",
    image: emp_icon_policy,
  },
  {
    id: 92184,
    label: "Payroll",
    link: "/app/employee/payroll/generate-payslip",
    color: "#E5D9F2",
    image: emp_payroll_generate,
  },
  {
    id: 92185,
    label: "Leave Balance",
    link: "/app/employee/leave-balance/generate-leave-balance",
    color: "#D7D3BF",
    image: emp_leave_balance_update,
  },
  {
    id: 75343,
    label: "Loan Details",
    link: "/app/employee/loan-details",
    color: "#E5E1DA",
    image: emp_loan_details,
  },
  {
    id: 75343,
    label: "Company Tree",
    link: "/app/employee/company-tree",
    color: "#E5E1DA",
    image: emp_loan_details,
  },
];
